import { Button as MuiButton, makeStyles } from '@material-ui/core'
import CheckInListingButton from './CheckInListingButton'
import CheckOutListingButton from './CheckOutListingButton'
import ExtendListingButton from './ExtendListingButton'
import DrawerActionButton from './DrawerActionButton'
import CheckOutDetailButton from './CheckOutDetailButton'

import { Loader } from 'packages/eid-ui'

const styles = {
    small: {
        padding: '3.25px 20px',
        minHeight: '35px',
    },
    medium: {
        padding: '5.25px 15px',
        minHeight: '39px',
    },
    large: {
        padding: '9.25px 30px',
        minHeight: '47px',
    },
}

const useStyles = makeStyles(() => ({
    root: (props) => ({
        textTransform: 'capitalize',
        fontSize: '16px',
        border: '1px solid transparent',
        borderRadius: '5px',
        ...props.variantStyles,
        ...props.style,
    }),
    startIcon: (props) => ({
        marginRight: props.size === 'large' ? '14px' : '10px',
    }),

    disabled: (props) => ({
        ...props.disabledStyles,
    }),
}))

const EidButton = (props) => {
    const {
        size,
        children,
        style,
        disabledStyles,
        loading,
        loaderColor,
        startIcon,
        endIcon,
        onClick,
        ...rest
    } = props
    const variantStyles = styles[size]

    const classes = useStyles({ style, variantStyles, size, disabledStyles })

    return (
        <MuiButton
            startIcon={!loading && startIcon}
            endIcon={!loading && endIcon}
            size={size}
            classes={classes}
            onClick={!loading ? onClick : undefined}
            {...rest}
        >
            {!loading ? (
                children
            ) : (
                <Loader
                    color={loaderColor ? loaderColor : '#ffffff'}
                    size={0.6}
                    height="0.5inh"
                />
            )}
        </MuiButton>
    )
}

EidButton.CheckInListing = CheckInListingButton
EidButton.CheckOutListing = CheckOutListingButton
EidButton.ExtendListing = ExtendListingButton
EidButton.DrawerActionButton = DrawerActionButton
EidButton.CheckOutDetailButton = CheckOutDetailButton

export default EidButton
